const setWatchList = (payload) => ({
    type: 'SET_WATCHLIST',
    payload,
});
const toggleFromWatchlist = (payload) => ({
    type: 'TOGGLE_FROM_WATCHLIST',
    payload,
});
const setUserPortfolio = (payload) => ({
    type: 'SET_USER_PORTFOLIO',
    payload,
});
const setAuth = (payload) => ({
    type: 'SET_AUTH',
    payload,
});
const setModalVisibility = (payload) => ({
    type: 'SET_MODAL_VISIBLE',
    payload,
});
const setUserImage = (payload) => ({
    type: 'SET_USER_IMAGE',
    payload,
});
const setUserDetails = (payload) => ({
    type: 'SET_USER_DETAILS',
    payload,
});
const setEmailFreqOptions = (payload) => ({
    type: 'SET_EMAIL_FREQ_OPTIONS',
    payload,
});
const setHelpVideo = (payload) => ({
    type: 'SET_HELP_VIDEO',
    payload,
});
const setPwdChangePopup = (payload) => ({
    type: 'SET_PWD_CHANGE_POPUP',
    payload,
});
const setShareUrls = (payload) => ({
    type: 'SET_SHARE_URLS',
    payload,
});
const setShareUrlsTitle = (payload) => ({
    type: 'SET_SHARE_URLS_TITLE',
    payload,
});
const setAnalystData = (payload) => ({
    type: 'SET_ANALYST_DATA',
    payload,
});
const setOtherAnalystData = (payload) => ({
    type: 'SET_OTHER_ANALYST',
    payload,
});
const setRecentDevelopments = (payload) => ({
    type: 'SET_RECENT_DEVELOPMENTS',
    payload,
});
const setHelperPage = (payload) => ({
    type: 'SET_HELPER_PAGE',
    payload,
});
const setIsFreeShareUrlDisabled = (payload) => ({
    type: 'SET_IS_FREE_SHARE_URL_DISABLED',
    payload,
});
const setActiveModal = (payload) => ({
    type: 'SET_ACTIVE_MODAL',
    payload,
});
const logout = () => ({
    type: 'LOGOUT',
});
export const mutation = {
    setWatchList,
    toggleFromWatchlist,
    setUserPortfolio,
    setAuth,
    setModalVisibility,
    setUserImage,
    setUserDetails,
    setEmailFreqOptions,
    setHelpVideo,
    setPwdChangePopup,
    setShareUrls,
    setShareUrlsTitle,
    setAnalystData,
    setOtherAnalystData,
    setRecentDevelopments,
    setHelperPage,
    setActiveModal,
    logout,
    setIsFreeShareUrlDisabled,
};
